import { render, staticRenderFns } from "./Politicas.vue?vue&type=template&id=41ed1ce1&scoped=true"
import script from "./Politicas.vue?vue&type=script&lang=ts"
export * from "./Politicas.vue?vue&type=script&lang=ts"
import style0 from "./Politicas.vue?vue&type=style&index=0&id=41ed1ce1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ed1ce1",
  null
  
)

export default component.exports